/** Word-level IPA overrides for Arabic. */
export const ar: Record<string, string> = {
  أحدا: '/ʔaˈħadan/', // anyone
  أحدهما: '/ʔaħaduˈhumaː/', // one of them two
  أحرارا: '/ʔaħˈraːran/',
  أسخيليوس: '/ʔasxiːˈliːjuːs/', // Aeschylus
  أمهات: '/umːaˈhaːt/',
  أنسيت: '/ʔunˈsiːt/',
  أنعمت: '/ʔanˈʕamta/',
  أورفليس: '/ʔurˈfaliːs/', // Orphalese (Gibran)
  أيديهم: '/ʔajˈdiːhim/',
  استيقظت: '/istajˈqaðˤtu/',
  اسمه: '/ˈismuhu/', // his name
  اعتزاله: '/iʕtiˈzaːlihi/', // his seclusion
  الأقاوال: '/alʔaqaːˈwiːl/', // the sayings/talk
  الأليفة: '/alʔaˈliːfah/',
  الأولى: '/alˈʔuːlaː/', // the first (fem.)
  الحياة: '/alħaˈjaːh/',
  الخليفة: '/alxaˈliːfah/',
  الخليقة: '/alxaˈliːqah/', // creation/nature
  الذكريات: '/aðːikraˈjaːt/',
  السماوات: '/asːamaːˈwaːt/',
  الضالين: '/adˤːaːˈliːn/',
  العالمين: '/alʕaːlaˈmiːn/',
  العشرة: '/alˈʕaʃara/', // the ten
  الغربة: '/alˈɣurbah/',
  الغزاة: '/alɣuˈzaːh/',
  الكرامة: '/alkaˈraːmah/',
  اللوى: '/alˈliwaː/',
  المصطفى: '/almusˈtˤafaː/',
  الندوات: '/annadaˈwaːt/', // the seminars/forums
  امرأة: '/imˈraʔah/',
  اهدنا: '/ihˈdinaː/',
  بأوقافه: '/biʔawˈqaːfihi/', // with his endowments
  بإذنه: '/biʔiðˈnihi/',
  ببرقة: '/biˈbarqah/', // in Barqa (place)
  بجزائر: '/bidʒaˈzaːʔir/', // with islands
  بداية: '/biˈdaːjah/',
  بذي: '/biˈðiː/', // of importance
  بشيء: '/biˈʃajʔ/',
  بعضا: '/ˈbaʕdˤan/',
  بعضهم: '/baʕˈdˤuhum/',
  بعينه: '/biˈʕajnihi/',
  بعينيها: '/biʕajˈnajhaː/',
  // Egyptian National Anthem — بلادي بلادي
  بلادي: '/biˈlaːdiː/', // my country
  بيدبا: '/bajdaˈbaː/', // Bidpai
  تأخذه: '/taʔˈxuðuhu/',
  تسقني: '/tasˈqiniː/',
  تعلمت: '/taʕalːˈamtu/',
  تقفن: '/taqifˈna/',
  تقلبت: '/taqalːaˈbat/', // it turned/fluctuated
  تكلمي: '/takalːaˈmiː/', // speak! (fem.)
  ثهمد: '/ˈθahmad/', // Thahmad (place name)
  جلست: '/dʒaˈlasat/',
  حارتنا: '/ħaːˈratnaː/',
  حفظهما: '/ħifˈðˤahumaː/',
  حكاية: '/ħiˈkaːjah/',
  حياته: '/ħaˈjaːtahu/',
  خفيفا: '/xaˈfiːfan/',
  خلالها: '/xiˈlaːlahaː/',
  خلفهم: '/xalˈfahum/',
  خمرا: '/ˈxamran/',
  دبشليم: '/dabʃaˈliːm/', // King Dabshelim
  رائحة: '/ˈraːʔiħah/',
  رافعا: '/ˈraːfiʕan/',
  رسمها: '/rasˈmuhaː/',
  رياحك: '/riˈjaːħaka/',
  زعموا: '/zaˈʕamuː/',
  زمانه: '/zaˈmaːnihi/',
  سادتي: '/saːˈdatiː/',
  ساسان: '/saːˈsaːn/', // Sasanian dynasty
  سبعة: '/ˈsabʕah/',
  ستحمله: '/sataħˈmiluhu/',
  سفينته: '/saˈfiːnatuhu/',
  سكرة: '/ˈsakrah/',
  سنة: '/ˈsanah/',
  سنين: '/siˈniːn/',
  شهريار: '/ʃahriˈjaːr/', // King Shahryar (1001 Nights)
  شيئا: '/ˈʃajʔan/',
  صباحا: '/sˤaˈbaːħan/', // morning
  صحبي: '/ˈsˤaħbiː/', // my companions
  صغارها: '/sˤiˈɣaːruhaː/',
  طالعا: '/ˈtˤaːliʕan/',
  طويلة: '/tˤaˈwiːlah/',
  // Ibn Khaldun — المقدمة
  ظاهره: '/ðˤaːˈhirihi/', // in its outward appearance
  عاما: '/ˈʕaːman/',
  عبلة: '/ˈʕablah/', // Abla (name)
  عجيبة: '/ʕaˈdʒiːbah/',
  عدت: '/ˈʕudtu/',
  عرفت: '/ʕaˈrafta/', // you knew
  عصره: '/ˈʕasˤrihi/',
  علمه: '/ˈʕilmihi/',
  عليك: '/ʕaˈlajka/',
  عليهم: '/ʕaˈlajhim/',
  عنده: '/ˈʕindahu/',
  عنها: '/ʕanˈhaː/', // about it
  غايتي: '/ɣaːˈjatiː/', // my goal
  غيبة: '/ˈɣajbah/',
  فإن: '/faˈʔin/',
  فاسقني: '/fasˈqiniː/',
  فاغتنمها: '/faɣˈtanimhaː/',
  فالمقراة: '/falˈmiqraːh/',
  فجرا: '/ˈfadʒran/',
  فحومل: '/faˈħawmal/',
  فما: '/faˈmaː/',
  فيه: '/fiːhi/',
  فيها: '/ˈfiːhaː/',
  قالت: '/ˈqaːlat/',
  قصة: '/ˈqisˤːah/',
  قلت: '/ˈqultu/', // I said
  كتابات: '/kitaːˈbaːt/',
  كرسيه: '/kurˈsijːuhu/',
  لخولة: '/lixawˈlatah/', // for Khawla (name)
  // Tarafa ibn al-Abd — المعلقة
  لكِ: '/ˈlaki/', // to you (fem.)
  لنيلك: '/liˈnajlika/', // for your Nile
  لوهلة: '/liˈwahlah/',
  مبنية: '/mabˈnijːah/',
  // Antara ibn Shaddad — المعلقة
  متردم: '/mutaˈradːim/', // worn out/in ruins
  متقطعا: '/mutaqatˤˈtˤiʕan/',
  مدينة: '/maˈdiːnah/',
  مطيهم: '/matˤajːaˈhum/', // their riding beasts
  // Abu al-Ala al-Ma'arri — غير مجد في ملتي
  ملتي: '/milːaˈtiː/', // my religion/creed
  مهيار: '/mahˈjaːr/', // Mahyar (Adonis)
  ميلاده: '/miːˈlaːdihi/',
  نسجتها: '/nasaˈdʒathaː/',
  نوما: '/ˈnawman/',
  هادما: '/ˈhaːdiman/',
  هوذا: '/haːˈðaː/',
  وأعوان: '/waʔaʕˈwaːn/', // and followers
  وإنما: '/waʔinːaˈmaː/',
  وإياك: '/waʔijˈjaːka/',
  واسلمي: '/waslaˈmiː/', // and farewell/be safe (fem.)
  واعتقادي: '/waʔiʕtiqaːˈdiː/', // and my belief
  والسنة: '/wasːˈanah/',
  والقال: '/walˈqaːl/', // and the talk
  والمحبة: '/walmaˈħabːah/',
  وبشروطه: '/wabiʃuˈruːtihi/', // and his conditions
  وحكايات: '/waħikaːˈjaːt/',
  وشبيه: '/waʃaˈbiːh/', // and similar to
  وشمأل: '/waʃaˈmaʔl/',
  وضعه: '/ˈwadˤʕihi/',
  وعلى: '/waˈʕalaː/', // and upon
  وعليهم: '/waʕaˈlajhim/',
  وغاب: '/waˈɣaːb/',
  وفؤادي: '/wafuˈʔaːdiː/', // and my heart
  وفطنة: '/waˈfitˤnah/',
  وقوفا: '/wuˈquːfan/', // standing
  وما: '/waˈmaː/',
  ومتساوين: '/wamutasaːˈwiːn/',
  ومنزل: '/waˈmanzil/',
  وهبوا: '/wuˈhibuː/',
  يؤوده: '/jaʔuːˈduhu/',
  يتخطى: '/jataˈxatˤːaː/',
  يحيطون: '/juħiːˈtˤuːn/',
  يضعه: '/jadˤaˈʕuhu/',
  يعاملوا: '/juˈʕaːmiluː/',
  يقولون: '/jaquːˈluːn/', // they say
  يهتموا: '/jahtamˈmuː/', // they cared
};
